import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AuthService from "../../services/auth.service";
import { setUser } from "../../stores/user";

const required = (value) => {
  if (!value) {
    return (
      <div
        className="alert alert-danger"
        role="alert"
      >
        This field is required!
      </div>
    );
  }
};
function Login() {
  const user = useSelector((store) => store.user);
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [servermessage, setServermessage] = useState("");
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const handleLogin = (e) => {
    e.preventDefault();
    AuthService.forgotpassword(email).then((response) => {
      if (response) {
        setServermessage(response.data.message);
        // dispatch(setUser(response.data));
        // navigate(location.pathname);
        // setSuccess(true);
      } else {
        console.log(response.data.error);
        setServermessage(response.data.error);
      }
    });
  };

  useEffect(() => {}, [success]);

  return (
    //  New Tailwind login form
    <div className="flex justify-center items-center min-h-screen">
      <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 w-full max-w-md">
        <span className="text-red-600">{servermessage}</span>
        <h2 className="text-3xl font-bold mb-6 text-center text-white">
          <span className="bg-gradient-to-r text-transparent from-blue-500 to-purple-500 bg-clip-text">
            Forgot Password
          </span>
        </h2>
        <form onSubmit={handleLogin}>
          <div className="mb-6">
            <label
              id="email"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              <i className="fas fa-envelope mr-2"></i>Email
            </label>
            <div>
              <input
                id="email"
                type="email"
                className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter your email"
                name="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                validations={[required]}
              />
            </div>
          </div>

          <div className="flex items-center justify-center">
            <button
              type="submit"
              className="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-700 hover:to-purple-700 text-white font-bold py-3 px-4 rounded focus:outline-none focus:shadow-outline w-full"
            >
              Reset Password
            </button>
          </div>
          <div className="flex row gap-36 text-center mt-4">
            <Link
              to="/register"
              className="text-gray-600 hover:underline"
            >
              New? Register
            </Link>
            <Link
              to="/login"
              className="text-gray-600 hover:underline "
            >
              Login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
